import type { JSX } from 'react';

import { MFormItem } from '../MFormItem/MFormItem';
import { MSelect, MSelectProps } from '../MSelect/MSelect';

export interface MFormSelectProps extends MSelectProps {
  label: string;
  tooltip?: {
    type: 'modal' | 'popover';
    title?: string;
    content: string | JSX.Element;
    icon?: 'info' | 'question';
  };
  alert?: string;
  weight?: 'light' | 'medium';
  align?: 'horizontal' | 'vertical';
  testId?: string;
}

export const MFormSelect = ({
  label,
  placeholder,
  tooltip,
  alert,
  weight = 'medium',
  align,
  value,
  options,
  defaultValue,
  onChange,
  onSelect,
  onDeselect,
  onSearch,
  error,
  disabled,
  allowClear,
  showSearch,
  showArrow,
  mode,
  loading,
  filterOption,
  className,
  testId,
}: MFormSelectProps) => {
  return (
    <MFormItem
      label={label}
      tooltip={tooltip}
      alert={alert}
      weight={weight}
      testId={testId}
      align={align}
      className={className}>
      <MSelect
        options={options}
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onSelect={onSelect}
        onDeselect={onDeselect}
        onSearch={onSearch}
        disabled={disabled}
        error={error}
        allowClear={allowClear}
        showSearch={showSearch}
        showArrow={showArrow}
        mode={mode}
        loading={loading}
        filterOption={filterOption}
        testId={testId}
      />
    </MFormItem>
  );
};
